export const ChatStatus = Object.freeze({
	Idle: "idle",
	Streaming: "streaming",
	Done: "done",
	Error: "error",
	Aborted: "aborted"
});

export const StreamFinishReason = Object.freeze({
	NoAnswer: "no-answer",
	RateLimited: "rate-limited",
	Forbidden: "forbidden",
	Done: "done",
	Error: "error",
	Aborted: "aborted"
});

export const ChatEventKind = Object.freeze({
	ConversationInfo: "ConversationInfo",
	ConversationStarted: "ConversationStarted",
	RunStarted: "RunStarted",
	PhaseChanged: "PhaseChanged",
	NoAnswer: "NoAnswer",
	RateLimitExceeded: "RateLimitExceeded",
	HtmlChunk: "HtmlChunk",
	Error: "Error",
	Done: "Done"
});

export const ChatPhase = Object.freeze({
	Analysing: "analysing",
	Retrieving: "retrieving",
	Generating: "generating"
});

//export const PanelStateChange = Object.freeze({
//	Loading: "loading",
//	Streaming: "streaming",
//	Done: "done",
//	None: "none"
//});

export const InteractionType = Object.freeze({
	ShowMoreButtonClicked: "ShowMoreButtonClicked"
});